import React from "react";
import { motion } from "framer-motion";
import { pageVariants } from "../animations/pageTransitions"; // Import animation config
import "./Pages.css";
import "./Capabilities.css";
import hema from "../../practices_images/hematology.jpg"; // Ensure this path is correct
import CollapsibleSection from "./CollapsibleSection"; // adjust path if needed

const Hematology = () => {
  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <div className="cap-container">
        <h1>Hematology</h1>

        <div className="cap-section">
          <div className="text-content">
            {/* ✅ First 2 sections: normal (always visible) */}
            <h3>Supporting complex care with operational precision</h3>
            <p>
              Hematology practices manage patients with complex and often chronic conditions that require careful monitoring, precise documentation, and coordinated care. Clinical decisions are closely tied to diagnostics, treatment protocols, and reimbursement accuracy.
            </p>
            <p>
              We partner with hematology practices to help them operate with clarity and consistency in a highly demanding clinical environment.
            </p>
  
            <h3>The Care Environment</h3>
            <p>
              Hematology care involves detailed documentation, frequent testing, and close coordination across clinical and administrative teams. Practices must meet strict compliance requirements while managing evolving treatment plans and payer expectations.
            <p>
            </p>
              Without aligned systems, administrative burden increases and operational risk grows.
            </p>
  
            {/* ✅ Everything after: collapsible */}
            <CollapsibleSection title="Our Role">
              <p>
                We help hematology practices strengthen the operational and financial processes that support high quality care delivery.
              </p>
              <p>
                Our work focuses on reinforcing documentation and coding accuracy, supporting reliable billing and reimbursement processes, improving financial visibility, and aligning workflows across clinical and administrative functions.
              </p>
              <p>
                Our approach reflects the rigor and precision required in hematology care.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Enabling Consistency and Control">
              <p>
                Our goal is to help practices operate with confidence and predictability.
              </p>
              <p>
                By improving operational consistency and financial clarity, we support reduced administrative burden, stronger compliance, and more reliable revenue. This allows care teams to focus on patients while leadership maintains control over practice performance.
              </p>
            </CollapsibleSection>
  
            <CollapsibleSection title="Looking Ahead">
              <p>
                As hematology care continues to advance, the need for strong operational foundations remains essential.
              </p>
              <p>
                We work with practices to build the structure and discipline required to support long term patient care and organizational stability.
              </p>
              <p>
                Let’s begin a conversation about how your practice can move forward with clarity and purpose.
              </p>
            </CollapsibleSection>
          </div>

          {/* Image Section */}
          <div className="image-container">
            <img src={hema} alt="Hematology" />
          </div>

        </div>
      </div>
    </motion.div>
  );
};

export default Hematology;
